export default __webpack_public_path__ + "static/media/credex-mobile-all.4b670b8f.png";